export default __webpack_public_path__ + "static/media/validation_mobile.0d670b2b.jpg";